import React from 'react';
import PropTypes from 'prop-types';
import reqwest from 'reqwest';
import ReactTable from 'react-table';

import settings from '../../../../../../settings';

import Loader from '../../../../../components/Loader';
import Button from '../../../../../components/Button';
import RightSide from '../../../../../components/FormArea/RightSide';
import ContentBox from '../../../../../components/FormArea/ContentBox';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import sortByDate from '../../../../../logic/sortByDate';

class ContractsOverview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      contractList: [],
      loading: true,
    };

    reqwest({
      method: 'get',
      url: settings.usermanagement.contracts.getList,
      contentType: 'json',
      data: {
        Token: localStorage.getItem('token'),
        UserGuid: this.props.UserGuid,
      },
    }).then(contractListResponse => {
      const contractList = JSON.parse(contractListResponse);
      this.setState({
        contractList,
        loading: false,
      });
    });
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    const data = this.state.contractList.filter(row => row.Params.Guid);

    return (
      <>
        <div className='FormArea-Form-Left'>
          <ContentBox title='Vertragsdaten'>
            <ReactTable
              getTrProps={(_, { original }) => ({
                onClick: () => this.props.history.replace(`${this.props.match.url}/${original.Params.Guid}`),
              })}
              data={data}
              pageSize={data.length}
              noDataText='Es liegen keine Verträge für den ausgewählten Benutzer vor.'
              defaultSorted={[
                {
                  id: 'Params.From',
                  desc: true,
                },
              ]}
              columns={[
                {
                  Header: 'Von',
                  accessor: 'Params.From',
                  sortMethod: sortByDate,
                },
                {
                  Header: 'Bis',
                  accessor: 'Params.To',
                  sortMethod: sortByDate,
                },
              ]}
            />
          </ContentBox>
        </div>
        <RightSide>
          <Button big icon={faPlus} to={`${this.props.match.url}/new`} replace>
            Neuer Vertrag
          </Button>
        </RightSide>
      </>
    );
  }
}

ContractsOverview.propTypes = {
  UserGuid: PropTypes.string.isRequired,
};

export default ContractsOverview;
